export const schema = {
  id: 'mobile-catering-gas-safety-record',
  name: 'Mobile Catering Vehicle / Trailer Gas Safety Record (UKLPG COP 24 / BS 6173)',
  description: 'Statutory Gas Safety Record for Mobile Catering Vehicles, Trailers, Food Trucks & Pop-up Kitchens',
  category: 'Gas Safety',
  sections: [
    {
      id: 'gasEngineerDetails',
      title: '1. Gas Safe Registered Engineer Details',
      fields: [
        { id: 'engineerName', label: 'Engineer Name', type: 'text', required: true },
        { id: 'gasSafeId', label: 'Gas Safe Registration Number', type: 'text', required: true },
        { id: 'engineerLicenceCardNo', label: 'Gas Safe Card / Licence ID', type: 'text', required: true },
        { id: 'companyName', label: 'Company Name', type: 'text', required: true },
        { id: 'companyAddress', label: 'Company Address', type: 'textarea', required: true },
        { id: 'telephone', label: 'Contact Telephone', type: 'tel', required: true }
      ]
    },
    {
      id: 'vehicleOwnerDetails',
      title: '2. Vehicle Operator & Trading Identity',
      fields: [
        { id: 'businessTradingName', label: 'Trading Name / Business Name', type: 'text', required: true },
        { id: 'operatorName', label: 'Operator / Responsible Person', type: 'text', required: true },
        { id: 'vehicleRegOrVin', label: 'Vehicle Registration No. / Trailer Chassis VIN', type: 'text', required: true },
        { id: 'vehicleMakeModel', label: 'Vehicle / Trailer Make & Description', type: 'text', required: true },
        { id: 'operatingBaseAddress', label: 'Registered Operating Base Address', type: 'textarea', required: true },
        { id: 'postCode', label: 'Postcode', type: 'text', required: true },
        { id: 'inspectionDate', label: 'Date of Inspection', type: 'date', required: true }
      ]
    },
    {
      id: 'lpgStorageCompartment',
      title: '3. LPG Cylinder Storage & Supply Integrity',
      fields: [
        { id: 'cylinderStorageType', label: 'LPG Storage Location', type: 'select', options: ['External Sealed Compartment (30-min Fire Resistant)', 'A-Frame Mounted Housing', 'Under-floor Dedicated Compartment', 'Freestanding External Siting'], required: true },
        { id: 'compartmentVentilation', label: 'Low & High Level Direct Ventilation (cm²)', type: 'select', options: ['Satisfactory / Clear to Atmosphere', 'Unsatisfactory / Obstructed'], required: true },
        { id: 'cylinderRestraints', label: 'Cylinders Securely Clamped in Upright Position?', type: 'select', options: ['Yes - Securely Strapped', 'No'], required: true },
        { id: 'changeoverRegulatorType', label: 'Regulator Type & OPSO/UPSO Fitted', type: 'text', required: true },
        { id: 'pigtailHoseCondition', label: 'High Pressure Pigtail Condition & Expiry Date Checked?', type: 'select', options: ['Pass - Within Service Date', 'Failed - Expired or Perished', 'Replaced on Site'], required: true },
        { id: 'emergencyIsolationValveAccessible', label: 'Emergency Gas Isolation Valve Accessible & Labelled?', type: 'select', options: ['Yes - Clearly Marked', 'No'], required: true }
      ]
    },
    {
      id: 'vehicleStructureAndVentilation',
      title: '4. Vehicle Fire Safety & Kitchen Ventilation',
      fields: [
        { id: 'fireLiningSatisfactory', label: 'Cooking Area Fire Resisting Lining (BS 476 Non-combustible)?', type: 'select', options: ['Satisfactory (Stainless Steel / Class 0)', 'Unsatisfactory'], required: true },
        { id: 'canopyExtractionOperational', label: 'Extraction Canopy & Air Movement Operable?', type: 'select', options: ['Yes - Mechanical Extraction', 'Natural Ventilation Sufficient', 'No / Defective'], required: true },
        { id: 'gasInterlockFitted', label: 'Gas Solenoid Interlocked with Extraction System?', type: 'select', options: ['Yes - Interlock Verified', 'No Interlock (Existing Spec)', 'N/A - Open Sided Trailer'], required: true },
        { id: 'gasTightnessTestPass', label: 'Gas Tightness Test at 37mbar (Propane) / 28mbar (Butane)', type: 'select', options: ['Pass - Zero Pressure Drop', 'Failed - Leak Detected'], required: true },
        { id: 'testPressureDropMbar', label: 'Recorded Pressure Drop over 2 Minutes (mbar)', type: 'number', required: true },
        { id: 'coAlarmFitted', label: 'Audible Carbon Monoxide (CO) Alarm Fitted & Tested (BS EN 50291-2)?', type: 'select', options: ['Yes - In Date & Tested', 'No - Warning Issued'], required: true }
      ]
    },
    {
      id: 'appliances',
      title: '5. Catering Appliances Safety Inspection',
      fields: [
        { id: 'appliance1', label: 'Appliance 1 (Make, Model & Type - e.g. Archway 4-Burner Doner Grill / Fryer)', type: 'text', required: true },
        { id: 'appliance1Ffd', label: 'Appliance 1 Flame Failure Device (FFD) Operable on ALL Burners?', type: 'select', options: ['Pass (FFD Closes <= 45s)', 'Failed', 'N/A'], required: true },
        { id: 'appliance1Visual', label: 'Appliance 1 Visual Condition & Secure Restraint', type: 'select', options: ['Pass', 'Fail'], required: true },
        { id: 'appliance2', label: 'Appliance 2 (Make, Model & Type)', type: 'text' },
        { id: 'appliance2Ffd', label: 'Appliance 2 Flame Failure Device (FFD)', type: 'select', options: ['Pass (FFD Closes <= 45s)', 'Failed', 'N/A'] },
        { id: 'appliance2Visual', label: 'Appliance 2 Visual Condition & Secure Restraint', type: 'select', options: ['Pass', 'Fail'] },
        { id: 'appliance3', label: 'Appliance 3 (Make, Model & Type)', type: 'text' },
        { id: 'appliance3Ffd', label: 'Appliance 3 Flame Failure Device (FFD)', type: 'select', options: ['Pass (FFD Closes <= 45s)', 'Failed', 'N/A'] },
        { id: 'appliance3Visual', label: 'Appliance 3 Visual Condition & Secure Restraint', type: 'select', options: ['Pass', 'Fail'] }
      ]
    },
    {
      id: 'safetyNoticeAndSignOff',
      title: '6. Final Safety Assessment & Statutory Handover',
      fields: [
        { id: 'overallResult', label: 'Overall Gas Installation Assessment', type: 'select', options: ['SAFE TO USE - SATISFACTORY', 'AT RISK (AR) - ADVISORY NOTICE ISSUED', 'IMMEDIATELY DANGEROUS (ID) - DISCONNECTED / ISOLATED'], required: true },
        { id: 'defectsNotes', label: 'Defects Identified / Remedial Action Required', type: 'textarea' },
        { id: 'nextInspectionDueDate', label: 'Next Annual Gas Safety Inspection Due', type: 'date', required: true },
        { id: 'engineerSignature', label: 'Gas Safe Engineer Signature', type: 'signature', required: true },
        { id: 'operatorSignature', label: 'Catering Operator Signature', type: 'signature', required: true }
      ]
    }
  ]
};

export default schema;
